<script lang="ts">
  /*                                                                              */
  /*                                                                                                                      */

  import BoxSizingBorderBox from "./BoxSizingBorderBox.svelte";

  let {
    contentBox = false,
  }: {
    contentBox?: boolean;
  } = $props();
</script>

{#if !contentBox}
  <BoxSizingBorderBox />
{/if}

<style lang="scss" global>
  @use "@otto-ec/otto-components-utils/scss/mixins";

  * {
    letter-spacing: unset;
    line-height: unset;
    word-spacing: unset;
  }

  :host {
    @include mixins.no-tap-highlight();
  }
</style>
